import { render } from "./TermsAndConditions.vue?vue&type=template&id=3b526cdc&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=3b526cdc&scoped=true&lang=css"

import exportComponent from "/tmp/build_ada65e43/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b526cdc"]])

export default __exports__